import t from "./highrise1780.mjs";
function e(a) {
  return t(this, a).has(a);
}
export {
  e as default
};
